export default "__VITE_ASSET__7352a2c6__"